import React from "react"
import "./ValueProposition.css"
import {
  HiCurrencyDollar,
  HiCog,
  HiLocationMarker,
  HiAcademicCap,
} from "react-icons/hi"

const ValueProposition = () => {
  const features = [
    {
      title: "Proven 8 Figure Model",
      description: "Flagship location doing $13.7M/year",
      icon: HiCurrencyDollar,
      highlight: "$13.7M",
    },
    {
      title: "Proprietary Tech Stack",
      description: "Fully integrated CRM, playbooks and tech stack",
      icon: HiCog,
      highlight: "Complete System",
    },
    {
      title: "Fully Protected Territory",
      description: "No overlap, full control of your market",
      icon: HiLocationMarker,
      highlight: "Exclusive Rights",
    },
    {
      title: "Comprehensive Training",
      description: "90-day onboarding and long-term support",
      icon: HiAcademicCap,
      highlight: "90-Day Launch",
    },
  ]

  return (
    <section className='value-proposition-section section section-green-light'>
      <div className='container'>
        <div className='animate-fade-up'>
          <h2 className='section-title'>
            Here's What You'll Get to Launch and Scale Your Staffing Business
            with Confidence
          </h2>
        </div>

        <div className='features-grid'>
          {features.map((feature, index) => (
            <div
              key={index}
              className='feature-card animate-scale-in'
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className='feature-header'>
                <div className='feature-icon'>
                  <feature.icon />
                </div>
                <div className='feature-highlight'>{feature.highlight}</div>
              </div>
              <h3 className='feature-title'>{feature.title}</h3>
              <p className='feature-description'>{feature.description}</p>
            </div>
          ))}
        </div>

        {/* <div
          className='value-stats animate-fade-up'
          style={{ animationDelay: "1s" }}
        >
          <div className='stat-item'>
            <div className='stat-number'>$13.7M</div>
            <div className='stat-label'>Annual Revenue</div>
          </div>
          <div className='stat-divider'></div>
          <div className='stat-item'>
            <div className='stat-number'>90 Days</div>
            <div className='stat-label'>To Launch</div>
          </div>
          <div className='stat-divider'></div>
          <div className='stat-item'>
            <div className='stat-number'>100%</div>
            <div className='stat-label'>Territory Protection</div>
          </div>
        </div> */}
      </div>
    </section>
  )
}

export default ValueProposition
